import { NgModule, ModuleWithProviders, InjectionToken, ANALYZE_FOR_ENTRY_COMPONENTS } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CounterUpDirective } from './counter-up.directive';
import { CounterUpConfig, CounterUpConfigArgs } from './counter-up.config';

export const /** @type {?} */ CounterUpOptions = new InjectionToken<CounterUpConfigArgs>('config');
/**
 * @param {?} config
 * @return {?}
 */
export function factoryCounterUpConfig(config: CounterUpConfigArgs) {
  return new CounterUpConfig(config);
}
export class CounterUpModule {
/**
 * @param {?=} config
 * @return {?}
 */
public static forRoot(config: CounterUpConfigArgs = {}): ModuleWithProviders {
    return {
      ngModule: CounterUpModule,
      providers: [
        { provide: CounterUpOptions, useValue: config },
        { provide: ANALYZE_FOR_ENTRY_COMPONENTS, multi: true, useValue: config },
        { provide: CounterUpConfig, useFactory: factoryCounterUpConfig, deps: [ CounterUpOptions ] }
      ]
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [ CommonModule ],
  declarations: [ CounterUpDirective ],
  exports: [ CounterUpDirective ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CounterUpModule_tsickle_Closure_declarations() {
/** @type {?} */
CounterUpModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CounterUpModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
